export const SN_RULE = 'rule'
export const RULE_RULES_UPDATED = SN_RULE + '/RULES_UPDATED'
export const RULE_GROUP_UPDATED = SN_RULE + '/GROUP_UPDATED'
export const RULE_REORDER_ACTIVE_UPDATED = SN_RULE + '/REORDER_ACTIVE_UPDATED'
export const RULE_ARCHIVED_RULES_UPDATED = SN_RULE + '/ARCHIVED_RULES_UPDATED'
export const RULE_CLEARED = SN_RULE + "/CLEARED"